<template>
  <div class="order-list">
    <el-card shadow="never">
      <div class="content">
        <div class="content-header">
            <el-form :inline="true" ref="vSearchForm" :model="query">
       
                   <el-form-item label="签约主体公司编码" prop="code">
               <el-select v-model="query.code" placeholder="签约主体公司编码">
                    <el-option value="" label="全部" />
            <el-option
              v-for="item in query.searchSelectOptions"
              :key="item.id"
              :label="item.code"
              :value="item.code"
            ></el-option>
          </el-select>
                   </el-form-item>
        <el-form-item label="签约主体公司名称" prop="company">
               <el-select v-model="query.company" placeholder="签约主体公司名称">
                    <el-option value="" label="全部" />
            <el-option
              v-for="item in query.searchSelectOptions"
              :key="item.id"
              :label="item.company"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="关联状态" prop="relation">
               <el-select v-model="query.relation" placeholder="关联状态">
            <el-option value="" label="全部" />
             <el-option value="1" label="已关联"/>
              <el-option value="0" label="未关联"/>
          </el-select>
         </el-form-item>
         
              <el-button type="primary" @click="searchButton">搜索</el-button>
              <el-button type="danger" @click="resetSearchForm">重置</el-button>
         
            </el-form>
        </div>
        <div class="content-main">
          <el-button type="primary" @click="openDialog" style="float:right;margin-bottom: 10px;" v-if="this.$permission.check('主体关联','新增')">新增</el-button>
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%; "
            v-loading="loading"
          >
            <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
            <el-table-column prop="code" label="签约主体公司编码" align="center"></el-table-column>
            <el-table-column prop="company" label="签约主体公司名称" align="center"></el-table-column>
            <el-table-column prop="wechatcomcode" label="微信收款主体公司编码" align="center"></el-table-column>
            <el-table-column prop="wechatcompany" label="微信收款主体公司名称" align="center"></el-table-column>
            <el-table-column prop="alipaycomcode" label="支付宝收款主体公司编码" align="center"></el-table-column>
            <el-table-column prop="alipaycompany" label="支付宝收款主体公司名称" align="center"></el-table-column>
            <el-table-column prop="status_text" label="关联状态" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="210">
              <template #default="scope">
                <el-button type="primary" size="small" @click="editDialog(scope.row)" v-if="this.$permission.check('主体关联','编辑')">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :total="pageTotal"
            
          ></el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog title="新增" v-model="formVisible" width="30%">
      <el-form ref="vform" :model="form" :rules="rules" label-width="180px" status-icon>
        <el-form-item label="签约主体公司编码" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="签约主体公司名称" prop="company">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item label="微信收款主体公司名称" prop="wechatcomcode">
          <el-select v-model="form.wechatcomcode" placeholder="请选择">
            <el-option value>请选择</el-option>
            <el-option
              v-for="item in form.wxoptions"
              :key="item.id"
              :label="item.company"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝收款主体公司名称" prop="alipaycomcode">
          <el-select v-model="form.alipaycomcode" placeholder="请选择">
            <el-option value>请选择</el-option>
            <el-option
              v-for="item in form.alioptions"
              :key="item.id"
              :label="item.company"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="id" hidden>
          <el-input v-model="form.id"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="resetForm('vform')">取 消</el-button>
          <el-button type="primary" @click="submitForm('vform')">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessageBox, ElNotification } from "element-plus";
import {
  listRelation,
  selectCollection,
  saveRelation,
  searchSelectRelation
} from "../api/serviceApi";

export default {
  data() {
    return {
      query: {
        company: "",
        code: "",
        relation:"",
        pageIndex: 1,
        pageSize: 10,
        searchSelectOptions:''
      },
      tableData: [],
      dialogTitle: "",
      formVisible: false,
      pageTotal: 0,
      pageTotalPro: 0,
      loading:false,
      form: {
        code: "",
        company: "",
        id: 0
      },

      rules: {
        code: [
          {
            required: true,
            message: "请输入签约主体公司编码",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        company: [
          {
            required: true,
            message: "请输入签约主体公司名称",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getData();
    this.getSelectCollectionData();
    this.getSearchSelectData();
  },
  methods: {
      searchButton(){
          this.getData();
      },
      getSearchSelectData(){
          searchSelectRelation().then(res=>{
            if(res.code==200){
                this.query.searchSelectOptions=res.data
            }
          })
      },
      resetSearchForm(){
          this.query.code='';
          this.query.company='';
          this.query.relation='';
          this.getData();
// this.$refs['vSearchForm'].resetFields();
      },
    openDialog() {
      this.form.id = 0;
      this.form.code = "";
      this.form.company = "";
      this.form.wechatcomcode = "";
      this.form.alipaycomcode = "";
      this.dialogTitle = "新增签约收款主体关联关系";
      
      this.formVisible = true;
    },
    editDialog(params) {
      this.dialogTitle = "编辑签约收款主体关联关系";
      this.form.id = params.id;
      this.form.code = params.code;
      this.form.company = params.company;
      this.form.wechatcomcode = params.wechatcomcode;
      this.form.alipaycomcode = params.alipaycomcode;
      this.formVisible = true;
    },
    getData() {
      this.loading=true
      let params = "?page=" + this.query.pageIndex+"&code="+this.query.code+"&company="+this.query.company+"&status="+this.query.relation;
      listRelation(params).then(res => {
       if(res.code==200){
           if(res.data.list){
                res.data.list.forEach(function(item) {
          if (item.status == 1) {
            item.status_text = "已关联";
          } else {
            item.status_text = "未关联";
          }
        });
        this.tableData = res.data.list;
        this.pageTotal = res.data.total;
        this.query.pageSize = res.data.size;
        this.query.pageIndex = res.data.page;
           }else{
                this.tableData =''
           }
       }
       this.loading=false
      });
      
    },
    getSelectCollectionData() {
      selectCollection().then(res => {
        if (res.code == 200) {
          this.form.wxoptions = res.data;
          this.form.alioptions = res.data;
        }
      });
    },
    resetForm(formName) {
      this.formVisible = false;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          saveRelation(this.form)
            .then(res => {
              if (res.code == 200) {
                ElNotification({
                  title: "成功",
                  message: "保存成功！",
                  duration: 2000,
                  type: "success"
                });
                this.getData();
                this.formVisible = false;
              }
            })
            .catch(e => {
              ElMessageBox.alert(e);
              return false;
            });
        } else {
          console.log("error");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less">
.el-row {
  margin-bottom: 20px;
}
</style>